import React, { useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

export default function Delete() { 
    const { id } = useParams();
    let navigate = useNavigate();

    const DeleteUser = () => { 
        axios.post('http://localhost:5000/DeleteUser', { id: id })
            .then((response) => { 
                if (response.status === 200) {
                    navigate('/Admin/Users');
                }

            })
            .catch((error) => { 
                console.log(error);
            });
    }

    useEffect(() =>  {
        DeleteUser();
    });

    useEffect(() => { 
        DeleteUser();
    }, []);
}